// src/features/common/OverlayedSingleDeveloperCard.jsx

import { Fragment } from "react";
import { Link } from "react-router-dom";
import PriceTag from "../../assets/common/PriceTag.svg";
import Image from "../../components/general/Image";
import DashedChips from "../../components/common/DashedChips";
import DummyProfile from "../../assets/common/DummyProfile.jpg";
import { EMPLOYMENT_TYPE } from "../../helpers/constants";
import Button from "../../components/general/Button";
import { getShrunkText } from "../../utils";

const OverlayedDeveloperCard = ({ developer, onClick }) => {
    if (!developer) return null;

    // Helper for skills
    const limitedSkills = developer.showMore
        ? developer.skills.slice(0, 9)
        : developer.skills.slice(0, 5);

    return (
        <Fragment>
            <div className="relative bg-[#292929] rounded-[10px] overflow-hidden min-h-[400px]">
                {/* --- Developer Card (background) --- */}
                <div className="block pointer-events-none">
                    {developer.display_pay_range && (
                        <div className="relative">
                            <Image className="absolute top-[20px] w-[80px] right-0 object-fill" src={PriceTag} alt="price-tag" />
                            <div className="relative z-1 top-[20px] pr-[10px] flex flex-col justify-end items-end">
                                <span className="font-bold text-[1.0rem] text-black"> ${developer.display_pay_range} </span>
                                <span className="block text-[0.6rem]">Per Hour</span>
                            </div>
                        </div>
                    )}
                    <div className="-mt-[20px]">
                        <div className="p-[20px]">
                            <div className="flex items-center justify-center">
                                <figure className="w-[100px] h-[100px]">
                                    <Image className="w-full h-full object-cover rounded-[6px]" src={developer.profile_picture ? developer.profile_picture : DummyProfile} alt="" />
                                </figure>
                            </div>
                            <div className="font-semibold text-[22px] mt-[20px] flex justify-center items-center gap-[10px]">
                                <span>{developer.first_name}</span>
                                {developer.country && developer.country.flag && (
                                    <Image className="w-[30px] h-[20px]" src={developer.country.flag.file} alt="" />
                                )}
                            </div>
                            <div className="text-center text-[#D7D7D7] font-extralight text-[0.8rem]">{developer.specialization}</div>
                            <div className="mt-[20px]">
                                <ul className="flex flex-wrap justify-start gap-[5px] items-center">
                                    {limitedSkills.map((skill, i) => (
                                        <DashedChips keyName={i} text={skill} />
                                    ))}
                                </ul>
                            </div>
                            <p className="text-center mt-[20px] text-[0.7rem] text-[#EFF1F6]" title={developer.about}>
                                {getShrunkText(developer.about, 100)}
                            </p>
                        </div>
                        <div className="flex justify-between items-center border-y border-[#8b8a8a] py-[10px]">
                            <div className="w-[50%] border-r border-[#8b8a8a]">
                                <p className="text-center text-[0.7rem] text-[#EFF1F6]">Experience</p>
                                <p className="text-center font-semibold text-primary-color text-[0.8rem]">{developer.total_experience} years</p>
                            </div>
                            <div className="w-[50%]">
                                <p className="text-center text-[0.7rem] text-[#EFF1F6]">Availability</p>
                                <p className="text-center font-semibold text-primary-color text-[0.8rem]">{EMPLOYMENT_TYPE[developer.availability]?.displayValue} only</p>
                            </div>
                        </div>
                        <div className="py-[8px]">
                            <div className="flex justify-between px-[20px] py-[10px]">
                                <span className="text-[0.8rem]">View Full profile</span>
                                <i className="fa-solid fa-arrow-up-right text-primary-color" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* --- Overlay (foreground) --- */}
                <div
                    className="absolute inset-0 flex flex-col items-center justify-center z-10 backdrop-blur-sm"
                    style={{
                        // Increased opacity for a stronger overlay
                        background: "linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.98))"
                    }}
                >
                    <div className="text-center mb-[15px]">
                        <span className="block uppercase font-bold text-[24px] text-white tracking-wide">VIEW MORE</span>
                        <span className="block font-normal text-[24px] text-white">Profiles</span>
                    </div>
                    <Button
                        onClick={onClick}
                        className="bg-primary-color text-black font-semibold px-6 py-3 rounded-lg shadow-lg text-lg"
                    >
                        Register Now
                    </Button>
                </div>
            </div>
        </Fragment>
    );
};

export default OverlayedDeveloperCard;